<h2>{{ header }}</h2>
<div class="container">
  <div class="card" *ngFor="let video of videos">
    <div class="card-img" [ngStyle]="{ 'background-image': 'url(' + video.youtubethumb + ') ' }">
      <img src="/assets/images/support/youtube.svg" alt="YouTube Image">
    </div>
    <div class="card-content">
      <h3>{{ video.title }}</h3>
    </div>
    <a (click)="showModal(video.youtubeid)"
      angulartics2On="click"
      angularticsCategory="Video - {{ sport }}"
      angularticsLabel="Section - {{ header }}"
      [angularticsProperties]="{ label: 'Title - ' + video.title }">
    </a>
  </div>
</div>
